import { FieldPattern } from '..';

import { BANNER } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import FormFieldWithInitialValue from '../FormFieldWithInitialValue';

class BannerFieldModel extends FormFieldWithInitialValue {
  readonly type: string = BANNER;
  isCloseAllow: boolean;
  imgLink: string | undefined;
  altText: string | undefined;
  description: string | undefined;
  heading: string | undefined;
  dependentOnFields: string[] | undefined;
  constructor(bannerData: FormFieldsType, initialValue = '') {
    super(bannerData, initialValue);
    const {
      isCloseAllow,
      imgLink,
      alt_text,
      description,
      heading,
      dependent_on_fields
    } = bannerData;
    this.isCloseAllow = isCloseAllow ?? true;
    this.imgLink = imgLink;
    this.altText = alt_text;
    this.description = description;
    this.heading = heading;
    this.dependentOnFields = dependent_on_fields;
  }
  t;
  match<T>(p: FieldPattern<T>): T {
    return p.BannerField(this);
  }
}
export default BannerFieldModel;
